import React, { useEffect, useState } from "react";
import Breadchrumb from "../components/Breadchrumb";
import { Link } from "react-router-dom";
import { getProducts } from "../data/products";



const Products = () => {
  useEffect(() => {
    document.title = "Products | Rack & Pinion, Ball Screws, LM Guides Supplier in Kathwada Ahmedabad Gujarat";
  }, []);
  useEffect(() => {
    async function fetchProducts() {
      const productsData = await getProducts();
      setProducts(productsData);
    }
    fetchProducts();
  }, []);

  const [products, setProducts] = useState([]);  
  const [selectedImage, setSelectedImage] = useState(null);

  return (

    <>
    {/* ---------- HERO SECTION ---------- */}
     <Breadchrumb pageName="Products" />
    <section className="products">
      <div className="container">
        <div className="section-header">
          <h2>Our <span>Products</span></h2>
          <p>
            Explore our range of high-quality Linear Motion Products in Ahmedabad Gujarat including Rack & Pinion, Ball Screws, SBR Shafts, and LM Guides designed with
            innovation, durability, and precision engineering.
          </p>
        </div>

        <div className="product-grid">
          {products.map((product) => (
            <div
              className="product-card"
              key={product.id}
              onClick={() => setSelectedImage(product.imageUrl)}
            >
              <img src={product.imageUrl} alt={product.name} />
              <h3>{product.name}</h3>
             <Link to={`/product/${product._id}`} className="view-details-btn">
    View Details <i className="fa-solid fa-arrow-right"></i>
  </Link>
            </div>
          ))}
        </div>

        {/* Modal Popup for Image Preview */}
        {selectedImage && (
          <div className="image-modal" onClick={() => setSelectedImage(null)}>
            <span className="close-btn">&times;</span>
            <img src={selectedImage} alt="Product Preview" className="modal-img" />
          </div>
        )}
      </div>
    </section>
    </>
  );
};

export default Products;
